import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import { TextEditorProps } from './types';

import { liveUpdateAttrs } from 'libs/contentful/utils';

const TextEditor = ({ sys, content, sectionName, bulletListStyle }: TextEditorProps) => {
  return (
    <section {...(sectionName != null && { id: encodeURIComponent(sectionName) })}>
      <div className="content-wrapper">
        <div
          className="rich-text-editor mx-0 my-10 font-serif text-body-serif font-medium text-content-primary white-colorway [&>*]:max-w-[800px] [&>p:has(.aspect-video)]:max-w-none"
          {...liveUpdateAttrs(sys?.id, 'content')}>
          <RichTextCopy copy={content} bulletListStyle={bulletListStyle} />
        </div>
      </div>
    </section>
  );
};

export default TextEditor;
